import React from "react";

interface DropdownMenuLabelProps {
  children: React.ReactNode;
  /** Additional CSS classes */
  className?: string;
}

/**
 * DropdownMenuLabel - A label for a group of menu items
 */
export function DropdownMenuLabel({
  children,
  className = "",
}: DropdownMenuLabelProps) {
  return (
    <div className={`px-2 py-1.5 text-sm font-semibold ${className}`}>
      {children}
    </div>
  );
}
